<template>
  <footer
    class="footer"
    :class="{ [`footer-${type}`]: type }"
    :data-background-color="backgroundColor"
  >
    <div class="container">
      <nav>
        <ul>
          <li>
            <a href="https://www.youtube.com/1WorshipPH" target="_blank">
              <i class="fab fa-youtube"></i>
            </a>
          </li>
          <li>
            <a href="https://open.spotify.com/artist/1FNtt9FjvJ9uUpYfixeVpd" target="_blank">
              <i class="fab fa-spotify"></i>
            </a>
          </li>
          <li>
            <a href="https://www.facebook.com/1WorshipPH/" target="_blank">
              <i class="fab fa-facebook-square"></i>
            </a>
          </li>
          <li>
            <a href="https://www.instagram.com/1worshipph/" target="_blank">
              <i class="fab fa-instagram"></i>
            </a>
          </li>
          <li>
            <a href="https://twitter.com/1worshipph" target="_blank">
              <i class="fab fa-twitter"></i>
            </a>
          </li>
        </ul>
      </nav>
      <div class="copyright">
        &copy; {{ year }} 1<b>WORSHIP</b>PH
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  props: {
    backgroundColor: String,
    type: String
  },
  data() {
    return {
      year: new Date().getFullYear()
    };
  }
};
</script>
<style></style>
